import { useEffect } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import { useJobVacancies } from './hooks/useJobVacancies'
import Card from 'components/card/Card'
import Pagination from 'components/pagination/Pagination'
import Errors from 'components/errors/Errors'
import { IconChecklistCircle } from 'components/icons'
import JobVacanciesCardHeader from './components/JobVacanciesCardHeader'
import JobVacancyTable from './components/JobVacancyTable'

export default function JobVacancyIndex() {
  const location = useLocation()
  const navigate = useNavigate()
  const useJobVacanciesHook = useJobVacancies()
  const loading = useJobVacanciesHook.fetchStatusJobVacancies === 'loading'
  const failed = useJobVacanciesHook.fetchStatusJobVacancies === 'error'
  const idle = useJobVacanciesHook.fetchStatusJobVacancies === 'idle'

  useEffect(() => {
    if (location.state && location.state.jobVacancyForm) {
      const message =
        location.state.jobVacancyForm === 'success-create-job-vacancy'
          ? 'Anda berhasil membuat pekerjaan baru'
          : 'Anda berhasil mengubah pekerjaan'
      useJobVacanciesHook.toast(message, 'success', <IconChecklistCircle color="white" />)
    }
    navigate('/job-vacancy', { replace: true })
  }, [])

  return (
    <div className="content-wrapper">
      {useJobVacanciesHook.toastContainer}
      <Card dataTestId="card_jobVacancyIndex" loading={loading} className="rounded-xl p-0 pb-2">
        <Card.Header className="px-4 py-2">
          <JobVacanciesCardHeader
            searchValueJobVacancies={useJobVacanciesHook.searchValueJobVacancies}
            selectedCategoryJobVacancies={useJobVacanciesHook.selectedCategoryJobVacancy}
            onClickAddJobVacancies={useJobVacanciesHook.handleOnNavigateToCreate}
            onChangeSearchValueJobVacancies={
              useJobVacanciesHook.handleOnChangeSearchValueJobVacancies
            }
            onPressEnterSearchValueJobVacancies={
              useJobVacanciesHook.handleOnEnterSearchValueJobVacancies
            }
            onChangeSelectedCategoryJobVacancies={
              useJobVacanciesHook.handleOnChangeSelectedCategoryJobVacancies
            }
          />
        </Card.Header>
        {idle && (
          <>
            <Card.Body className="mt-0">
              <JobVacancyTable
                data={useJobVacanciesHook.jobVacancies}
                loading={loading}
                onSort={useJobVacanciesHook.handleOnChangeSort}
                onClickDetail={(id: string) => useJobVacanciesHook.handleOnNavigateToDetail(id)}
                columnsSortBy={useJobVacanciesHook.sortDirectionJobVacancies}
                columnsSortField={useJobVacanciesHook.sortFieldJobVacancies}
              />
            </Card.Body>
            <Card.Footer>
              <div className="px-4 py-3">
                <Pagination
                  totalRows={useJobVacanciesHook.totalPageJobVacancies}
                  currentPage={useJobVacanciesHook.pageJobVacancies}
                  limit={useJobVacanciesHook.limitJobVacancies}
                  showLimitPage={true}
                  setLimit={(limit: number) =>
                    useJobVacanciesHook.handleOnChangeLimitJobVacancies(limit)
                  }
                  onPageChanged={(page: number) =>
                    useJobVacanciesHook.handleOnChangePageJobVacancies(page)
                  }
                />
              </div>
            </Card.Footer>
          </>
        )}
        {failed && (
          <Errors
            data-testid="error_fetch_job_vacancies"
            inverse={false}
            header="Mohon maaf, permintaan Anda tidak dapat diproses."
            paragraph="terjadi kesalahan internal pada server kami. Silakan coba beberapa saat lagi."
            button={true}
            buttonLabel="Coba lagi"
            buttonAction={useJobVacanciesHook.fetchJobVacancies}
          />
        )}
      </Card>
    </div>
  )
}
